export const loginFields = (props) => {
  if (!props.email) return false;
  if (!props.password) return false;
  return { email: props.email, password: props.password };
}
